"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectToSignUp = exports.redirectToSignIn = void 0;
const backend_1 = require("@clerk/backend");
const server_1 = require("next/server");
const clerkClient_1 = require("./clerkClient");
const redirectAdapter = (url) => server_1.NextResponse.redirect(url);
_a = (0, backend_1.redirect)({
    redirectAdapter,
    signInUrl: clerkClient_1.SIGN_IN_URL,
    signUpUrl: clerkClient_1.SIGN_UP_URL,
    publishableKey: clerkClient_1.PUBLISHABLE_KEY,
    frontendApi: clerkClient_1.FRONTEND_API,
}), exports.redirectToSignIn = _a.redirectToSignIn, exports.redirectToSignUp = _a.redirectToSignUp;
